import HeroSection from '@/components/custom/ui/clients/tempula/booking/heroSection'
import { HomestayHome } from '@/components/custom/ui/clients/tempula/home/home'
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter'
import HomestayNavbar from '@/components/custom/ui/clients/tempula/homestay/homestayNavbar'
import HomeConfig from '@/constant/config/clients/tempula/home/homeConfig'
import HomeheroConfig from '@/constant/config/clients/tempula/homestay/homeheroConfig'
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig'
import HomenavConfig from '@/constant/config/clients/tempula/homestay/homestayNavConfig'
import { createFileRoute } from '@tanstack/react-router'
import { SEO, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/home')({
    head: () => buildPageHead(SEO.home),
    component: RouteComponent,

})

function RouteComponent() {
    return (
        <div className="bg-BgGallery">
            <div className="fixed top-0 left-0 w-full z-50">
                <HomestayNavbar {...HomenavConfig} />
            </div>
            <HeroSection {...HomeheroConfig} />
            <HomestayHome {...HomeConfig} />
            <HomestayFooterCmp {...HomestayfooterConfig} />
        </div>
    )
}
